/* @ngInject */
const sterileRequest = (
  $q,
  utils,
  valueHandler,
  sterileResource,
  sterileFormat,
  errorHandler,
  labels
) => {
  const self = {}

  self.getBySearch = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$sterile.getBySearch'
      const data = sterileFormat.server(_data)
      sterileResource.post({ action: 'search', }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            steriles: res.data,
            message: labels.sterile.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.sterile.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.save = (_sterile) => {
    return $q((resolve, reject) => {
      const functionName = '$$sterile.save'
      const data = utils.copy(_sterile)
      sterileResource.save({}, data, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: res.message,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.sterile.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _sterile)
            reject(labels.sterile.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.saveAll = (_steriles, _wagonId) => {
    const loopPromises = []

    utils.forEach(_steriles, async (sterile) => {
      const deferred = $q.defer()
      loopPromises.push(deferred.promise)
      sterile.wagonId = _wagonId

      try {
        const response = await self.save(sterile)
        deferred.resolve(response)
      } catch (error) {
        deferred.reject(error)
      }
    })
    return $q.all(loopPromises)
  }

  self.delete = (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$$sterile.delete'
      sterileResource.delete({ action: _id, }, (res) => {
        if (res.success) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.sterile.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getByWagon = async (_wagonId) => {
    return $q((resolve, reject) => {
      const functionName = '$$sterile.getByWagon'

      sterileResource.post({ action: 'get-by-wagon', }, { wagonId: _wagonId, }, (res) => {
        if (res && res.success && res.message) {
          resolve(res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _wagonId)
          reject(labels.sterile.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}
export default sterileRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/request.service.js